import { TemplateChannel, ValidNonScheduledType } from 'entities/campaign/rulesets/channels';
import { TFunction } from 'react-i18next';

interface ChannelType {
  heading: string;
  defaultValue: TemplateChannel;
}

const channelTypeConfig: (translator: TFunction<'campaigns'>) => { [key in ValidNonScheduledType]: ChannelType } = (
  translator: TFunction<'campaigns'>,
) => ({
  '.Email': {
    heading: translator('channel.email'),
    defaultValue: {
      type: '.Email',
      templateId: undefined,
      delay: 0,
    },
  },
  '.RTMInjectedChannel': {
    heading: translator('channel.injectedRTM'),
    defaultValue: {
      rtmTrigger: [{ type: '.Immediately' }],
      type: '.RTMInjectedChannel',
      templateId: undefined,
    },
  },
  '.RTMOverlayChannel': {
    heading: translator('channel.overlaidRTM'),
    defaultValue: {
      rtmTrigger: [{ type: '.Immediately' }],
      type: '.RTMOverlayChannel',
      templateId: undefined,
    },
  },
  '.SMS': {
    heading: translator('channel.sms'),
    defaultValue: {
      type: '.SMS',
    },
  },
  '.WhatsApp': {
    heading: translator('channel.whatsapp'),
    defaultValue: {
      type: '.WhatsApp',
    },
  },
});

export function getChannelConfig(channelType: ValidNonScheduledType, translator: TFunction<'campaigns'>): ChannelType {
  return channelTypeConfig(translator)[channelType];
}

export function getChannelWithPredefinedTemplateId(
  channelType: ValidNonScheduledType,
  templateId: string,
  translator: TFunction<'campaigns'>,
): TemplateChannel {
  return {
    ...channelTypeConfig(translator)[channelType].defaultValue,
    templateId,
  };
}
